/**
 * ConfigSelectField — wrapper de select M3 Outlined para /settings.
 * Prefixo Config conforme isolamento F3.
 * Tem pelo menos 2 casos de uso: unidades, tipo de negocio, idioma, frequencia.
 *
 * placeholder: quando value === '' e placeholder esta definido, exibe uma
 * opcao desabilitada como estado honesto ("dado nao disponivel").
 */

interface SelectOption {
  readonly value: string;
  readonly label: string;
}

interface ConfigSelectFieldProps {
  readonly id: string;
  readonly label: string;
  readonly options: readonly SelectOption[];
  readonly value: string;
  readonly onChange: (value: string) => void;
  /** Se true, ocupa a ultima posicao do bloco (sem borda inferior) */
  readonly isLast?: boolean;
  /**
   * Texto exibido como opcao inicial desabilitada quando value === ''.
   * Representa estado honesto: dado ainda nao disponivel no backend.
   */
  readonly placeholder?: string;
}

export function ConfigSelectField({
  id,
  label,
  options,
  value,
  onChange,
  isLast = false,
  placeholder,
}: ConfigSelectFieldProps): JSX.Element {
  const fieldClass = isLast ? 'cfg-field cfg-field--last' : 'cfg-field';
  const showPlaceholder = placeholder !== undefined && value === '';

  return (
    <div className={fieldClass}>
      <label className="cfg-label" htmlFor={id}>
        {label}
      </label>
      <div className="cfg-select-wrap">
        <select
          className="cfg-select"
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label={label}
        >
          {showPlaceholder ? (
            <option value="" disabled>
              {placeholder}
            </option>
          ) : null}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className="material-symbols-rounded cfg-select-arrow" aria-hidden="true">
          expand_more
        </span>
      </div>
    </div>
  );
}
